import { createFileRoute } from '@tanstack/react-router'
import { MenuCard } from '@/entities/menu-card'
import { useCafeteriaMenuInfo } from '@/shared/api/cafeteria-menu'

export const Route = createFileRoute(
  '/_auth/canteen/menu-settings/catalog-menu/details/$menuCardId/common'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { menuCardId } = Route.useParams()
  const { data, isLoading, isError } = useCafeteriaMenuInfo({ id: menuCardId })
  return <MenuCard menuInfo={data?.menuInfo} isLoading={isLoading} isError={isError} />
}
